import React from 'react';
import { Card, CardContent, Box, Typography, Skeleton } from '@mui/material';

const EarningStatCard = ({ icon, value, label, loading }) => {
  if (loading) {
    return (
      <Card sx={{ borderRadius: 3, boxShadow: 3 }}>
        <CardContent>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Skeleton variant="rectangular" width={40} height={40} sx={{ borderRadius: 1.5 }} />
            <Box>
              <Skeleton variant="text" width={100} height={32} />
              <Skeleton variant="text" width={80} height={20} />
            </Box>
          </Box>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card sx={{ borderRadius: 3, boxShadow: 3, width: '100%' }}>
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Box sx={{ p: 1.5, bgcolor: 'grey.800', borderRadius: 1.5, display: 'inline-flex', color: 'white' }}>
            {icon}
          </Box>
          <Box>
            <Typography variant="h5" component="p" sx={{ fontWeight: 'bold' }}>
              {value}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {label}
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default EarningStatCard;
